<template>
    <div>
        <div v-if="!isMobile" class="Commandes">
            <!--            <div class="header">-->
            <!--                <p class="hello">{{ }}</p>-->
            <!--                <el-row class="box" type="flex" align="middle">-->
            <!--                    <p class="SubTitle">{{ langPage['l.general']['TXT_mescommandes'] }}</p>-->
            <!--                    <span class="flexGrow1"/>-->
            <!--                    <p class="logout" @click="logout">{{ langPage['l.general']['TXT_deconnexion'] }}</p>-->
            <!--                </el-row>-->
            <!--            </div>-->
            <el-collapse accordion class="menu">
                <el-collapse-item name="CARACTERISTIQUES">
                    <template slot="title">
                        <span class="title">MENU</span>
                    </template>
                    <div class="kidList">
                        <p v-for="(item,key) of routerlist" :key="key"
                           class="itemDesc"
                           @click="$router.push(item.path)">{{ item.name[0] }}</p>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div class="selectList">
                <div>
                    <el-select @change="initLoad" class="selectItem" v-model="value"
                               :placeholder="langPage['bov-commandes-liste']['TXT_vendeur']">
                        <el-option
                            v-for="item in commandes"
                            :key="item.id_commande"
                            :label="item.vendeur.nomBoutique"
                            :value="item.id_vendeur">
                        </el-option>
                    </el-select>
                    <el-select @change="initLoad" class="selectItem" v-model="years"
                               :placeholder="langPage['mobile-compte-commande-filtre']['TXT_annee']">
                        <el-option
                            v-for="(item,indexs) in yearList"
                            :key="indexs"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                    <el-select @change="initLoad" class="selectItem" v-model="months"
                               :placeholder="langPage['mobile-compte-commande-filtre']['TXT_mois']">
                        <el-option
                            v-for="item in monty"
                            :key="item"
                            :label="item"
                            :value="item<10?'0'+item:item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="filter">
                <el-tag closable @close="clear('Vendeur')" v-if="value">{{ langPage['bov-commandes-liste']['TXT_vendeur'] }}</el-tag>
                <el-tag closable @close="clear('Année')" v-if="years">Année</el-tag>
                <!--                <el-tag closable @click="clear('Mois')" v-if="months">{{-->
                <!--                        langPage['bov-commandes-transporteurs-ups']['TXT_mois']-->
                <!--                    }}</el-tag>-->
                <span class="notbg" @click="clear('all')" v-if="value||years">Effacer les filtres</span>
            </div>
            <!-- 分页 -->
            <pagination
                v-show="total>0"
                :total="total"
                :page-sizes="[24,48,198]"
                :page.sync="page"
                :limit.sync="limit"
                class="pagination-auto"
                @pagination="init"
            />
            <div v-if="active==0" v-loading="isLoading">
                <div class="paramsHeader">
                    <div class="firstItem">{{ langPage['compte-commandes-liste']['TXT_commandes'] }}</div>
                    <div>{{ langPage['lookbooks-grossistes']['TXT_date'] }}</div>
                    <div class="transportName">{{ langPage['compte-commandes-details']['TXT_transporteur'] }}</div>
                    <div>{{ langPage['compte-commandes-liste']['TXT_totalpaye'] }} H.T</div>
                    <div>{{ langPage['compte-commandes-liste']['TXT_totalpaye'] }} T.T.C</div>
                    <div>{{ langPage['compte-commandes-liste']['TXT_moyendepaiement'] }}</div>
                    <div></div>
                    <div>{{ langPage['compte-commandes-liste']['TXT_nsuivi'] }}</div>
                </div>
                <el-collapse v-for="(item,index) of dataList" :key="index" v-model="activeName" class="self-collapse" @change="change">
                    <el-collapse-item>
                        <template slot="title">
                            <div class="commandeItemBox">
                                <span :class="sel_list.indexOf(index+1)>=0?'el-icon-minus':'el-icon-plus'"></span>
                                <div style="font-weight: bold">{{ item.id_commande_groupe }}</div>
                                <div>{{
                                        item.commandes[0] && item.commandes[0].dateCommande ? item.commandes[0].dateCommande : ""
                                    }}
                                </div>
                                <div class="transportName">{{
                                        item.commandes[0] && !commonUtils.isEmpty(item.commandes[0].livraison) ? item.commandes[0].livraison.libelle : ""
                                    }}
                                </div>
                                <div>{{ item.totalPrixHt.toFixed(2) }}</div>
                                <div>{{ item.taxRate ? item.totalPrixTTC.toFixed(2) : '-' }}</div>
                                <div>
                                    <i v-if="item.id_paiement===2" class="fa fa-credit-card" aria-hidden="true"
                                       style="margin-left: 0.5vw"></i>
                                    <i v-if="item.id_paiement===3" class="fa fa-exchange" aria-hidden="true"
                                       style="margin-left: 0.5vw"></i>
                                </div>

                                <div class="el-link" @click.stop="todetaills(index,item)" style="text-decoration: underline">
                                    {{ langPage['compte-commandes-virement']['TXT_voirdetails'] }}
                                </div>

                                <div class="itemCommandContent el-link"
                                     v-if="commonUtils.isEmpty(getTransportData(item)[0][0])">
                                    -
                                </div>
                                <el-popover
                                    v-else
                                    placement="right"
                                    width="400"
                                    trigger="click">
                                    <div v-for="(commandeDeliver,index) of getTransportData(item)"
                                         :key="index"
                                         class="el-link"
                                         style="display: block"
                                         @click="onClickTurnToTransportByDeliver(commandeDeliver)">
                                        {{ commandeDeliver[0] ? commandeDeliver[0].transportOrderId : '' }}
                                    </div>
                                    <div class="itemCommandContent el-link"
                                         slot="reference">
                                        {{ getTransportData(item)[0] ? getTransportData(item)[0][0].transportOrderId.substr(0,5) + langPage ['compte-commandes-liste']['TXT_voirplus'] : '' }}
                                    </div>
                                </el-popover>
                                <div @click="onClickDownloadOrderBillImg(item)" class="transportName">
                                    {{ langPage['compte-commandes-liste']['TXT_facture'] + ' ' + langPage['compte-commandes-liste']['TXT_fraisdeport'] }}
                                </div>
                                <div class="el-link" @click.stop="toPrintCommandes(index,item)" style="text-decoration: underline">
                                    {{ langPage['compte-commandes-liste']['TXT_resume'] }}
                                </div>
                            </div>
                        </template>
                        <template v-if="item.commandes && item.commandes.length>0">
                            <div class="commandeItemDetailBox">
                                <div class="paramsBox">
                                    <div>
                                        <span>{{ langPage['compte-commandes-liste']['TXT_statut'] }}</span>
                                    </div>
                                    <div>
                                        <span>{{ langPage['catalogue-tendances']['TXT_vendeur'] }}</span>
                                    </div>
                                    <div>
                                        <span>{{ langPage['compte-commandes-liste']['TXT_articles'] }}</span>
                                        <p>HT</p>
                                    </div>
                                    <div>
                                        <div/>
                                        <p>TTC</p>
                                    </div>
                                    <div>
                                        <span>{{ langPage['boa-commandes-ruptures']['TXT_ruptures'] }}</span>
                                        <p>HT</p>
                                    </div>
                                    <div>
                                        <div/>
                                        <p>TTC</p>
                                    </div>
                                    <!--                                    <div>-->
                                    <!--                                        <span>{{ langPage['compte-commandes-liste']['TXT_ruptures'] }}</span>-->
                                    <!--                                        <p>HT</p>-->
                                    <!--                                    </div>-->
                                    <!--                                    <div>-->
                                    <!--                                        <div/>-->
                                    <!--                                        <p>TTC</p>-->
                                    <!--                                    </div>-->
                                    <div>
                                        <!--                                        <span>Tracking</span>-->
                                        <!--                                        <p>number</p>-->
                                        <p>{{ langPage['compte-commandes-liste']['TXT_nsuivi'] }}</p>
                                    </div>
                                    <div>
                                        <span>{{ langPage['compte-commandes-liste']['TXT_facture'] }}</span>
                                    </div>
                                    <div>
                                        <span>Photos</span>
                                    </div>
                                    <div>
                                        <span>{{ langPage['compte-commandes-liste']['TXT_details'] }}</span>
                                    </div>
                                </div>
                                <div v-for="(i,index2) of item.commandes" :key="index2" class="detailValueBox">
                                    <div class="circleBox">
                                        <span class="circle" :style="getStatutStyle(i.commandes_statut.id_statut)"></span>
                                        <el-tooltip class="item" effect="dark" :content="i.commandes_statut[`statut_${$store.state.lang}`]" placement="top">
                                            <span class="circleDesc">{{
                                                    i.commandes_statut[`statut_${$store.state.lang}`].length > 20
                                                        ? i.commandes_statut[`statut_${$store.state.lang}`].substring(0, 20) + '...'
                                                        : i.commandes_statut[`statut_${$store.state.lang}`]
                                                }}</span>
                                        </el-tooltip>
                                    </div>
                                    <div>{{ i.vendeur ? i.vendeur.nomBoutique : '' }}</div>
                                    <div>{{ i.montantApresRemise !== '0.00' ? i.montantApresRemise + '€' : '-' }}</div>
                                    <div>{{ item.taxRate ? i.total_ttc + '€' : '-' }}</div>
                                    <div>{{ i.ligne[0] && i.ligne[0].prixLigne !== '0.00' ? i.ligne[0].prixLigne + '€' : '-' }}</div>
                                    <div>{{ i.ligne[0] && i.ligne[0].prixLigne !== '0.00' && item.taxRate ? Number(i.ligne[0].prixLigne).mul(1 + item.taxRate) + '€' : '-' }}</div>
                                    <div>
                                         <span
                                             class="transportNo"
                                             v-for="(transport,transportIndex) of getTransportData(item)[index2]"
                                             :key="transportIndex"
                                             @click="onClickTurnToTransportByDeliver(transport)">
                                        {{ !commonUtils.isEmpty(transport) ? transport.transportOrderId : '' }}
                                        </span>
                                    </div>

                                    <div>-</div>
                                    <div>
                                        <a :href="base.dev + `/v2/produits/downloadPictures?id_commande=${item.id_commande}`"
                                           @click="onClickDownloadOrderImg"
                                           v-loading="is_downloading_prod_file">
                                            <div>
                                                <img src="@/assets/img/photo.svg" alt/>
                                            </div>
                                        </a>
                                    </div>
                                    <div>
                                        <div @click="todetaills(index,item)" class="blackBtnCommandes">{{ langPage['v4-goodslist']['TXT_voirlacommande'] }}</div>
                                    </div>
                                </div>
                                <div class="transportBox">
                                    <div>{{ langPage['compte-commandes-liste']['TXT_fraisdeport'] }}</div>
                                    <div></div>
                                    <div>{{ item.frais_port !== '0.00' ? item.frais_port + ' €' : '-' }}</div>
                                    <div> {{
                                            item.frais_port !== '0.00' && item.frais_port && item.taxRate ? (Number(item.frais_port) * (1 + Number(item.taxRate))).toFixed(2) + '€' : '-'
                                        }}
                                    </div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div @click="onClickDownloadOrderBillImg(item)" class="cursorPointer">
                                        {{ langPage['compte-commandes-liste']['TXT_facture'] + ' ' + langPage['compte-commandes-liste']['TXT_fraisdeport'] }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-collapse-item>
                </el-collapse>
                <h3 v-if="commonUtils.isEmpty(dataList)" class="noCommande">{{ langPage['compte-commandes-liste']['TXT_nonecommandeacheteur'] }}</h3>
            </div>
        </div>
        <div v-if="isMobile" class="mCommandes">
            <!--            <div class="header">-->
            <!--                <p class="hello">{{ langPage['compte-identification']['TXT_bonjour'] }}</p>-->
            <!--                <el-row class="box" type="flex" align="middle">-->
            <!--                    <p class="SubTitle">{{ $store.state.userInfo.prenomContact + $store.state.userInfo.nomContact }}</p>-->
            <!--                    <span class="flexGrow1"/>-->
            <!--                    <p class="logout" @click="logout">{{ langPage['l.general']['TXT_deconnexion'] }}</p>-->
            <!--                </el-row>-->
            <!--            </div>-->
            <el-collapse accordion class="menu">
                <el-collapse-item name="CARACTERISTIQUES">
                    <template slot="title">
                        <span class="title">MENU</span>
                    </template>
                    <div class="kidList">
                        <p v-for="(item,key) of routerlist" :key="key"
                           class="itemDesc"
                           @click="$router.push(item.path)">{{ item.name[0] }}</p>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <div class="selectList">
                <div>
                    <el-select @change="initLoad" class="selectItem" v-model="value"
                               :placeholder="langPage['bov-commandes-liste']['TXT_vendeur']">
                        <el-option
                            v-for="item in commandes"
                            :key="item.id_commande"
                            :label="item.vendeur.nomBoutique"
                            :value="item.id_vendeur">
                        </el-option>
                    </el-select>
                    <el-select @change="initLoad" class="selectItem" v-model="years"
                               :placeholder="langPage['mobile-compte-commande-filtre']['TXT_annee']">
                        <el-option
                            v-for="(item,indexs) in yearList"
                            :key="indexs"
                            :label="item"
                            :value="item">
                        </el-option>
                    </el-select>
                    <el-select @change="initLoad" class="selectItem" v-model="months"
                               :placeholder="langPage['mobile-compte-commande-filtre']['TXT_mois']">
                        <el-option
                            v-for="item in monty"
                            :key="item"
                            :label="item"
                            :value="item<10?'0'+item:item">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="filter">
                <el-tag closable @close="clear('Vendeur')" v-if="value">{{ langPage['bov-commandes-liste']['TXT_vendeur'] }}</el-tag>
                <el-tag closable @close="clear('Année')" v-if="years">Année</el-tag>
                <!--                <el-tag closable @click="clear('Mois')" v-if="months">{{-->
                <!--                        langPage['bov-commandes-transporteurs-ups']['TXT_mois']-->
                <!--                    }}</el-tag>-->
                <span class="notbg" @click="clear('all')" v-if="value||years">Effacer les filtres</span>
            </div>
            <!-- 分页 -->
            <pagination
                v-show="total>0"
                :total="total"
                :page-sizes="[24,48,198]"
                :page.sync="page"
                :limit.sync="limit"
                class="pagination-auto"
                @pagination="init"
            />
            <div v-if="active==0" v-loading="isLoading">
                <!--                <div class="paramsHeader">-->
                <!--                    <div class="firstItem">id</div>-->
                <!--                    <div>{{ langPage['lookbooks-grossistes']['TXT_date'] }}</div>-->
                <!--                    <div>{{ langPage['compte-commandes-details']['TXT_transporteur'] }}</div>-->
                <!--                    <div>{{ langPage['v4-collapse']['TXT_ttpayeht'] }}</div>-->
                <!--                    <div>{{ langPage['v4-collapse']['TXT_ttpayettc'] }}</div>-->
                <!--                    <div>Payment method</div>-->
                <!--                </div>-->
                <el-collapse v-for="(item,index) of dataList" :key="index" v-model="activeName" class="self-collapse" @change="change">
                    <el-collapse-item>
                        <template slot="title">
                            <div>
                                <div class="commandeItemBox">
                                    <div style="font-weight: bold">{{ item.id_commande_groupe }}</div>
                                    <div class="transportLine">
                                        <div class="firstItem">{{
                                                item.commandes[0] && !commonUtils.isEmpty(item.commandes[0].livraison) ? item.commandes[0].livraison.libelle : ""
                                            }}
                                        </div>
                                        <div class="flexGrow1"></div>
                                        <div class="el-link" @click.stop="todetaills(index,item)" style="text-decoration: underline">
                                            {{ langPage['compte-commandes-virement']['TXT_voirdetails'] }}
                                        </div>
                                    </div>
                                    <div>{{
                                            item.commandes[0] && item.commandes[0].dateCommande ? item.commandes[0].dateCommande : ""
                                        }}
                                    </div>
                                    <div>{{ item.totalPrixTTC.toFixed(2) }}€</div>
                                </div>
                            </div>
                        </template>
                        <template v-if="item.commandes && item.commandes.length>0">
                            <div class="commandeItemDetailBox">
                                <div v-for="(i,index2) of item.commandes" :key="index2" class="detailValueBox">
                                    <div>{{ i.commandes_statut[`statut_${$store.state.lang}`] }}</div>
                                    <div>{{ i.vendeur.nomBoutique }}</div>
                                    <div class="priceBox">
                                        <p class="priceItem">{{ langPage['compte-commandes-liste']['TXT_articles'] }}</p>
                                        <p class="priceItem">ht</p>
                                        <p class="priceItem">{{ i.montantApresRemise !== '0.00' ? i.montantApresRemise + '€' : '-' }}</p>
                                        <p class="priceItem">ttc</p>
                                        <p class="priceItem">{{ item.taxRate ? i.total_ttc + '€' : '-' }}</p>
                                    </div>
                                    <div>
                                        <a :href="base.dev + `/v2/produits/downloadPictures?id_commande=${item.id_commande}`"
                                           @click="onClickDownloadOrderImg"
                                           v-loading="is_downloading_prod_file">
                                            <div>
                                                <img src="@/assets/img/photo.svg" alt/>
                                            </div>
                                        </a>
                                    </div>
                                    <!--                                    <div @click="todetaills(index,item)" class="cursorPointer">...</div>-->
                                </div>
                                <div class="transportBox">
                                    <div>Transport cost</div>
                                    <div>HT {{ item.frais_port !== '0.00' ? item.frais_port + ' €' : '-' }}</div>
                                    <div>TTC {{
                                            item.frais_port !== '0.00' && item.frais_port ? (Number(item.frais_port) * (1 + Number(item.taxRate))).toFixed(2) + '€' : '-'
                                        }}
                                    </div>
                                    <div @click="onClickDownloadOrderBillImg(item)" class="cursorPointer">Invoice Transport cost</div>
                                </div>
                            </div>
                        </template>
                    </el-collapse-item>
                </el-collapse>
                <h3 v-if="commonUtils.isEmpty(dataList)" class="noCommande">{{ langPage['compte-commandes-liste']['TXT_nonecommandeacheteur'] }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
import goodsList from "../components/goodsList";
import collapse from "../components/collapse";
import base from "../api/base";
import pagination from "@/components/pagination";


let formatUtils = require('@/utils/format');
let transportHelper = require('@/utils/helper/Checkout/transport_helper');
let commonUtils = require('@/utils/common_utils');
let loginHelper = require('@/utils/helper/Login/login_helper');

export default {
    name: "Commandes2",
    components: {
        goodsList,
        collapse,
        pagination,
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        },
    },
    data() {
        return {
            isMobile: this.$store.state.isMobile,
            commonUtils,
            formatUtils,
            transportHelper,
            loginHelper,
            activeName: [],
            sel_list: [],
            id_acheteur: localStorage.getItem('id_acheteur'),
            yearList: [],
            monty: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
            commandes: [],
            pageSize: 24,
            page: 1,
            limit: 24,
            dates: "",
            months: "",
            years: "",
            dataList: [],
            active: 0,
            tabList: ["Par commandes", "Par articles"],
            no: 0,
            value: "",
            list: [],
            total: 0,
            is_show_filter: false,
            isLoading: false,
            isFirstLoadData: true,//是否是第一次获取数据
            is_downloading_prod_file: false,
            base: base,
            routerlist: [
                {
                    name: [this.$store.state['langPage']['mobile-compte']['TXT_title_1']],
                    path: "/Moncompte/Informations"
                },
                {
                    name: [this.$store.state['langPage']['v4-entreprise']['TXT_monentreprise']],
                    path: "/Moncompte/Entreprise"
                },
                {
                    name: [this.$store.state['langPage']['v4-lastthing']['TXT_mesadresses']],
                    path: "/Moncompte/Adresses"
                },
                {
                    name: [this.$store.state['langPage']['compte-menu']['TXT_mestransporteurs']],
                    path: "/Moncompte/Transporteurs"
                },
                // {
                //   name: "Mes moyens de paiement",
                //   path: "/Moncompte/Moyens"
                // },
                {
                    name: [this.$store.state['langPage']['compte-menu']['TXT_mescommandes'], this.$store.state['langPage']['v4-lastthing']['TXT_monarticles']],
                    path: "/Commandes"
                },
                {
                    name: [this.$store.state['langPage']['catalogue-filtres']['TXT_promotions']],
                    path: "/promotions"
                },
                {
                    name: [this.$t("account.word1")],
                    path: "/"
                }
            ]
            // datas:[
            //   {meta:'name1',children:[{meta:'child1'}]},
            //   {meta:'name2'},
            //   {meta:'name3',children:[{meta:'child3'},{meta:'child31'}]},
            //   {meta:'name4',children:[{meta:'child4'}]},
            //   {meta:'name5'},
            // ],
            // ap:['name2','name3','child31','name5']
        };
    },
    created() {
        this.init();
        this.getCommandes()
        this.getvender()
        // this.getVal(this.datas, this.ap)
    },
    watch: {},
    methods: {
        getCommandes() {
            let commandesArr = [];
            let newArr = []
            this.$api.info.orderList({
                id_vendeur: "",
                id_acheteur: "",
                page: this.page,
                pageSize: this.limit,
                date: "",
            }).then(res => {
                if (res.code != 0) {
                    if (this.isFirstLoadData) {
                        this.isFirstLoadData = false;
                        this.getCommandes();
                    }
                    return;
                }
                for (var i = 0; i < res.data.list.length; i++) {
                    commandesArr = commandesArr.concat(res.data.list[i].commandes)
                }
                for (let j = 0; j < commandesArr.length; j++) {
                    for (let k = j + 1; k < commandesArr.length; k++) {
                        if (
                            !commonUtils.isEmpty(commandesArr[j])
                            && !commonUtils.isEmpty(commandesArr[k])
                            && (commandesArr[j].vendeur.nomBoutique == commandesArr[k].vendeur.nomBoutique)) {
                            commandesArr.splice(k, 1)
                            j--
                        }
                    }
                }
                this.commandes = commandesArr;
                // if (!commonUtils.isEmpty(this.commandes)) {
                //     this.list = this.commandes[0].produits;
                // }
                this.total = res.data.page.total;
                this.$forceUpdate();
            })
        },
        initLoad() {
            if (this.yearList && !this.months) this.months = '01';
            if (this.years && this.months || this.value) this.init()
        },
        init() {
            let para = {
                id_vendeur: this.value,
                id_acheteur: "",
                page: this.page,
                pageSize: this.limit,
                date: this.years && this.months ? this.years + '-' + this.months : ""
            }
            this.isLoading = true;
            this.$api.info.orderList(para).then(res => {
                this.isLoading = false;
                this.total = res.data.page.total
                let data = res.data.list;
                this.dataList = data;
                let curArr = []
                let monty = []
                this.dataList.forEach((item, index) => {
                    for (var i = 0; i < item.commandes.length; i++) {
                        let year = item.commandes[i].dateCommande.split('-')[2]
                        let mon = item.commandes[i].dateCommande.split('-')[1]
                        let val = `${year}-${mon}`
                        monty.push(mon)
                        curArr[index] = year
                        break
                    }
                })
                // if (commonUtils.isEmpty(this.monty)){
                //     let arrs = []
                //     for (var j = 0; j < monty.length; j++) {
                //         if (monty.indexOf(monty[j]) == j) {
                //             arrs.push(monty[j])
                //         }
                //     }
                //     this.monty = arrs.sort((a, b) => {
                //         return a - b
                //     })
                // }

                if (commonUtils.isEmpty(this.yearList)) {
                    let arrsYear = []
                    for (var k = 0; k < curArr.length; k++) {
                        if (curArr.indexOf(curArr[k]) == k) {
                            arrsYear.push(curArr[k])
                        }
                    }
                    this.yearList = arrsYear
                }
                this.$forceUpdate();
            })
        },
        clear(str) {
            if (str == 'Vendeur')
                this.value = ''
            else if (str == 'Année')
                this.years = ''
            else if (str == 'Mois')
                this.months = ''
            else this.months = '', this.years = '', this.value = ''
            this.init()
        },
        getvender() {
            this.$api.info.getvender({
                id_vendeur: "",
                id_acheteur: "",
                page: "",
                pageSize: "",
                start_time: "2020-04-08",
                end_time: "2020-04-08"
            }).then(res => {
                console.log(res)
            })
        },
        closeTag(i) {
            this.selectval.splice(i, 1);
        },
        deletAll() {
            for (var i in this.selectval) {
                this.selectval.splice(i, 1, "");
            }
        },
        foldshow(i) {
            this.no = i;
        },
        chooseTab(i) {
            this.active = i;
        },
        goDetail(item) {
            let url = `/ProductDetail?id=${item.id_produit}&vendu_par=${item.vendu_par}&vid=${item.id_vendeur}&categorie_id=${item.id_categorie}`;
            window.open(url, '_blank');
        },
        goCommande() {
            let commande = this.commandes[0];
            let url = `/moncompte/crticles?commandeId=${commande.id_commande_groupe}&acheteurId=${this.$store.state.userInfo.id_acheteur}`;
            window.open(url, '_blank');
        },
        todetaills(val, data) {
            // let commandeStr = ''
            // data.commandes.forEach((item)=>{
            //   commandeStr+=item.id_commande+','
            // })
            let query = {
                // commandeId: commandeStr.substring(0,commandeStr.length-1),
                commandeId: data.id_commande_groupe,
                acheteurId: data.commandes[0].id_acheteur
            }
            this.$router.push({path: "/moncompte/crticles", query});
        },
        toPrintCommandes(val, data) {
            // let commandeStr = ''
            // data.commandes.forEach((item)=>{
            //   commandeStr+=item.id_commande+','
            // })
            let query = {
                // commandeId: commandeStr.substring(0,commandeStr.length-1),
                commandeId: data.id_commande_groupe,
                acheteurId: data.commandes[0].id_acheteur
            }
            this.$router.push({path: "/printCommandes", query});
        },
        change() {
            let arrs = new Array(this.dataList.length).fill(0);
            for (var i = 0; i < this.activeName.length; i++) {
                for (var k = 0; k < arrs.length; k++) {
                    arrs[i] = parseInt(this.activeName[i]) + 1;
                }
            }
            this.sel_list = arrs;
            // console.log(this.sel_list)
        },
        ruptHts(data) {
            //计算税前价格总和
            let num = 0;
            data.forEach(item => {
                num += parseFloat(item.prixLigne);
            });
            return num;
        },
        //下载账单图片
        onClickDownloadOrderBillImg(item) {
            let lang = this.$store.state.lang == 'fr' ? 'fr' : 'uk';
            let url = `${this.$common.imgHost}facturePDF/${lang}/${this.$store.state.userInfo.id_acheteur}/${item.id_commande_groupe_name + lang.toUpperCase()}.pdf`
            // return;
            window.open(url, '_blank');
        },
        //跳转到物流公司的详情过去
        onClickTurnToTransport(item) {
            item = item.commandes[0];
            let url = transportHelper.getDeliverUrl(item.livraison);
            console.log(url)
            if (!url) return this.$message.error(`can't get deliver data`);
            window.open(url, '_blank');
        },
        //跳转到物流公司的详情过去
        onClickTurnToTransportByDeliver(deliver) {
            let url = deliver.url;
            console.log(url)
            if (!url) return this.$message.error(`can't get deliver data`);
            window.open(url, '_blank');
        },
        getTransportData(commandeGroup) {
            if (commonUtils.isEmpty(commandeGroup.commandes[0].livraison)) return [];
            let transportDatas = [];
            for (let commande of commandeGroup.commandes) {
                let arrDeliverData = [];
                if (!commonUtils.isEmpty(commande.commandes_etiquettes)) {
                    for (let commandes_etiquette of commande.commandes_etiquettes) {
                        commande.livraison.transportData = JSON.parse(commandes_etiquette.etiquette);
                        let data = transportHelper.getDeliverData(commande.livraison);
                        arrDeliverData.push(data);
                    }
                }
                transportDatas.push(arrDeliverData);
            }
            return transportDatas;
        },
        onClickDownloadOrderImg(item) {
            if (this.is_downloading_prod_file) return;
            this.is_downloading_prod_file = true;
            let that = this;
            setTimeout(function () {
                that.is_downloading_prod_file = false;
                that.$forceUpdate();
            }, 20000);
        },
        logout() {
            loginHelper.logout(this);
        },
        getStatutStyle(commandes_statut) {

            switch (commandes_statut) {
                case 1:
                    return 'background-color:#ffcf9f;color:#000000;font-weight:bold;';
                //EN ATTENTE DE CONFIRMATION
                case 4:
                    return 'background-color:#f1e969;color:#000000;font-weight:bold;';
                //EN ATTENTE D'EXPEDTION
                case 2:
                    return 'background-color:#cbf59e;color:#000000;font-weight:bold;';
                //EXPEDIEE
                case 3:
                    return 'background-color:#f1bebe;color:#000000;font-weight:bold;';
                //ANNULER
                case 5:
                    return 'background-color:#F22613;color:#ffffff;font-weight:bold;';
                //EN ATTENTE DE PREUVE DE VIREMENTS
                case 11:
                    return 'background-color:#FCADA6;color:#000000;font-weight:bold;';
                //EN ATTENTE DE VALIDATION HERO
                case 12:
                    return 'background-color:#E69128;color:#000000;font-weight:bold;';
                //COMMANDE BLOQUEE
            }
        }
    }
}
</script>

<style lang="less" scoped src="@/assets/viewCss/views/Commandes2.less">
</style>
